import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import {
  BALL_IN_PLAY,
  EVENTS,
  MATCH,
  MATCH_EVENTS,
  MP4_STRING,
  PLAYS,
  STREAM,
  videoTypeAtom,
} from '../../atoms/selectedVideoData';
import themeHelper from '../../utils/themeHelper';

const DropdownContainer = styled.div`
  padding: ${themeHelper.spacing(0.5, 0)};
`;

export function VideoTypeSelection({
  allowBallInPlay,
  allowIdProvision,
  allowMatchEvents,
  allowStreams,
  allowUrls,
}) {
  const intl = useIntl();

  const [videoType, setVideoType] = useAtom(videoTypeAtom);

  const VIDEO_TYPES = [
    ...(allowIdProvision
      ? [
          {
            label: intl.formatMessage({
              defaultMessage: 'Soccer Events',
              id: '01743',
            }),
            value: EVENTS,
          },
          {
            label: intl.formatMessage({
              defaultMessage: 'AMF Plays',
              id: '1009b',
            }),
            value: PLAYS,
          },
        ]
      : []),
    {
      label: intl.formatMessage({
        defaultMessage: 'Match from library',
        description: 'Match',
        id: 'e203d',
      }),
      value: MATCH,
    },
    ...(allowBallInPlay
      ? [
          {
            label: intl.formatMessage({
              defaultMessage: 'Ball In Play',
              id: 'bd9d1',
            }),
            value: BALL_IN_PLAY,
          },
        ]
      : []),
    ...(allowMatchEvents
      ? [
          {
            label: intl.formatMessage({
              defaultMessage: 'Soccer Match Events',
              id: '43a19',
            }),
            value: MATCH_EVENTS,
          },
        ]
      : []),
    ...(allowUrls
      ? [
          {
            label: intl.formatMessage({
              defaultMessage: 'MP4',
              id: '96e81',
            }),
            value: MP4_STRING,
          },
        ]
      : []),
    ...(allowStreams
      ? [
          {
            label: intl.formatMessage({
              defaultMessage: 'Stream',
              id: 'eae83',
            }),
            value: STREAM,
          },
        ]
      : []),
  ];

  return (
    <DropdownContainer>
      <Dropdown
        id="video-type-selection"
        isSearchable={false}
        label={intl.formatMessage({
          defaultMessage: 'Type',
          id: 'a1fa2',
        })}
        labelPosition="left"
        onChange={(selected) => setVideoType(selected.value)}
        options={VIDEO_TYPES}
        value={VIDEO_TYPES.find((option) => option.value === videoType)}
        variant="secondary"
      />
    </DropdownContainer>
  );
}
VideoTypeSelection.propTypes = {
  allowBallInPlay: PropTypes.bool,
  allowIdProvision: PropTypes.bool,
  allowMatchEvents: PropTypes.bool,
  allowStreams: PropTypes.bool,
  allowUrls: PropTypes.bool,
};
VideoTypeSelection.defaultProps = {
  allowBallInPlay: false,
  allowIdProvision: false,
  allowMatchEvents: false,
  allowStreams: false,
  allowUrls: false,
};

export default VideoTypeSelection;
